import React, { useContext } from 'react';
import { KibEditIcon } from '@chewy/kib-icons-react';
import { KibButtonNew } from '@chewy/kib-controls-react';
import { useHistory } from 'react-router-dom';
import { getPetEditPath } from '../../util/config';
import AnalyticsContext from '../../context/AnalyticsContext';
import { conditionalHistoryPush } from '../../util/helpers';

const EditProfileButton = ({
  petProfileId,
  name,
  footer = false,
  className,
}: {
  petProfileId: number;
  name: string;
  footer?: boolean;
  className?: string;
}) => {
  const editProfileCopy = 'Edit Profile';
  const history = useHistory();
  const analytics = useContext(AnalyticsContext);
  const handleClick = () => {
    analytics.trackEvent('new-pet-profile', 'edit', 'view-details', null, {
      sourceView: 'pet-profile-v2',
      petId: petProfileId,
    });
    conditionalHistoryPush(getPetEditPath(petProfileId), history);
  };

  return !footer ? (
    <KibButtonNew
      data-testid="edit-profile"
      aria-label={`Edit ${name}'s profile`}
      emphasis="tertiary"
      size="medium"
      icon={<KibEditIcon aria-hidden="true" focusable="false" />}
      onClick={handleClick}
      className={className}
    >
      {editProfileCopy}
    </KibButtonNew>
  ) : (
    <KibButtonNew
      data-testid="edit-profile"
      aria-label={`Edit ${name}'s profile`}
      emphasis="primary"
      size="large"
      onClick={handleClick}
      className={className}
    >
      {editProfileCopy}
    </KibButtonNew>
  );
};
export default EditProfileButton;
